export default __webpack_public_path__ + "static/media/badge-dedicated-icon.f3f991cb.svg";